import React from 'react';
import PropTypes from 'prop-types';
import { Map as GoogleMap, GoogleApiWrapper, Marker, InfoWindow } from 'google-maps-react';
import Geocode from 'react-geocode';
import './map-multilocation.css';

class MapMultilocation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      markers: [],
      activeMarker: null,
      bounds: null,
      showingInfoWindow: false,
    };
    this.onMarkerClick = this.onMarkerClick.bind(this);
    this.onMapClicked = this.onMapClicked.bind(this);
  }

  componentDidMount() {
    const apiKey = process.env.STORYBOOK_MAPS_API_KEY;
    const { locations } = this.props;

    locations.forEach(location => {
      const address = this.getAddressFromLocation(location);
      Geocode.fromAddress(address, apiKey).then(geocodeData => {
        this.addMarker(location, address, geocodeData);
      });
    });
  }

  onMarkerClick(props, marker, e) {
    this.setState({
      activeMarker: marker,
      showingInfoWindow: true,
    });
  }

  onMapClicked(props) {
    const { showingInfoWindow } = this.state;
    if (showingInfoWindow) {
      this.setState({
        activeMarker: null,
        showingInfoWindow: false,
      });
    }
  }

  getAddressFromLocation(location) {
    const { street, city, state, zip_code, country } = location;
    return `${street}, ${city}, ${state}, ${zip_code}, ${country}`;
  }

  addMarker(location, address, geocodeData) {
    const latLongData = geocodeData.results[0].geometry.location;
    const { markers } = this.state;

    const newMarkers = [];
    newMarkers.push(...markers);
    newMarkers.push({
      key: newMarkers.length,
      title: location.location_name,
      address,
      lat: latLongData.lat,
      lng: latLongData.lng,
    });

    this.updateBounds(newMarkers);
    this.setState({ markers: newMarkers });
  }

  updateBounds(markers) {
    const bounds = new window.google.maps.LatLngBounds();

    markers.forEach(marker => {
      const latLng = new window.google.maps.LatLng(marker.lat, marker.lng);
      bounds.extend(latLng);
    });
    this.setState({ bounds });
  }

  render() {
    const { google } = this.props;
    const { bounds, markers, activeMarker, showingInfoWindow } = this.state;

    return (
      <div className="map-multilocation-wrapper">
        <GoogleMap google={google} bounds={bounds} zoom={16} onClick={this.onMapClicked}>
          {markers.map(mrkr => (
            <Marker
              key={mrkr.key}
              onClick={this.onMarkerClick}
              title={mrkr.title}
              address={mrkr.address}
              position={{ lat: mrkr.lat, lng: mrkr.lng }}
            />
          ))}

          <InfoWindow marker={activeMarker} visible={showingInfoWindow}>
            <div>
              {activeMarker && (
                <>
                  <h4 style={{ marginBottom: '0' }}>{activeMarker.title}</h4>
                  <p>{activeMarker.address}</p>
                </>
              )}
            </div>
          </InfoWindow>
        </GoogleMap>
      </div>
    );
  }
}

MapMultilocation.propTypes = {
  locations: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      street: PropTypes.string.isRequired,
      city: PropTypes.string.isRequired,
      state: PropTypes.string.isRequired,
      zipCode: PropTypes.string.isRequired,
      country: PropTypes.string,
    }),
  ),
};

MapMultilocation.defaultProps = { locations: [] };

export default GoogleApiWrapper({
  apiKey: process.env.GOOGLE_MAPS_API_KEY,
})(MapMultilocation);
